define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/action/Controller",
	"csi/comm/PostRequest"
], function(declare,lang,Controller,PostRequest) {

	return declare(Controller, {
		process: function() {
			// summary: issue request so as to be able to receive return value
			var	req = this.m_action.m_request;

			this.setProgress();

			var request = new PostRequest(req.m_module, req.m_operation)
				.addParameter("Data",this.getFormData().getFieldInitialValue("Data"));

			this.when(request.post(), lang.hitch(this, this._onPublishResponse));
		},

		postProcessSuccess: function() {
			this.widget.refreshData();
		},

		getStringParameters: function() {
			var rowCount = 0;

			if (this.m_response != null && this.m_response.isValid() && this.m_response.isSuccessful()) {
				rowCount = this.getFormData().getFieldInitialValue("RowCount");
			}

			return [this.inherited(arguments), rowCount];
		}
	});
});